export const BUSINESS = {
  name: "N.P. GunSmith & Sales",
  short: "N.P. Guns",
  phone: "(928) 444-5905",
  phoneHref: "tel:+19284445905",
  address: "4520 AZ-95, Fort Mohave, AZ 86426",
  city: "Fort Mohave, Arizona",
  rating: 4.4,
  reviewCount: 24,
  yelp: "https://www.yelp.com/biz/np-gunsmith-and-sales-fort-mohave-2",
  mapEmbed: "https://maps.google.com/maps?q=4520%20AZ-95%2C%20Fort%20Mohave%2C%20AZ%2086426&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const HOURS = [
  { day: "Mon", open: "9:00 AM", close: "5:00 PM" },
  { day: "Tue", open: "9:00 AM", close: "5:00 PM" },
  { day: "Wed", open: "9:00 AM", close: "5:00 PM" },
  { day: "Thu", open: "9:00 AM", close: "5:00 PM" },
  { day: "Fri", open: "9:00 AM", close: "5:00 PM" },
  { day: "Sat", open: "9:00 AM", close: "3:00 PM" },
  { day: "Sun", open: "9:00 AM", close: "3:00 PM" },
];

export const SERVICES = [
  {
    no: "01",
    title: "Firearm Sales",
    desc: "New and used pistols, rifles, and shotguns from the brands you trust. If we don't have it, we'll order it.",
  },
  {
    no: "02",
    title: "Gunsmithing & Repairs",
    desc: "Diagnostics, part replacement, and full restorations handled by knowledgeable, hands-on armorers.",
  },
  {
    no: "03",
    title: "Cleaning & Maintenance",
    desc: "Keep your firearm dependable with professional deep cleans, lubrication, and function tune-ups.",
  },
  {
    no: "04",
    title: "Custom Work & Builds",
    desc: "Bespoke rifle and pistol builds tailored to your specs — from optics to triggers to finish.",
  },
  {
    no: "05",
    title: "FFL Transfers",
    desc: "Fast, compliant transfers handled with care. Local support for your online purchases.",
  },
  {
    no: "06",
    title: "NFA & Class 3 (SOT)",
    desc: "As a licensed SOT dealer, we handle suppressors, short-barreled rifles, and other NFA items — sales and transfers done by the book.",
  },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1765513265796-3c21b92cb516?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Tactical Rifle & Mag", tag: "Rifles" },
  { url: "https://images.unsplash.com/photo-1610165539809-f37ec6d2f987?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Modern Sporting Rifle", tag: "Rifles" },
  { url: "https://images.unsplash.com/photo-1627411149005-c4c5dace32ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Match Ammunition", tag: "Ammo" },
  { url: "https://images.unsplash.com/photo-1610165539750-051008c3e799?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Precision Bolt Action", tag: "Rifles" },
  { url: "https://images.unsplash.com/photo-1700774607099-8c4631ee9764?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "The Workbench", tag: "Gunsmithing" },
  { url: "https://images.unsplash.com/photo-1595844982356-460cd2764fdf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Carry Pistol", tag: "Handguns" },
  { url: "https://images.unsplash.com/photo-1610165539774-791ae89d0574?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Custom Build", tag: "Custom" },
  { url: "https://images.unsplash.com/photo-1580865783874-7d9e701e858a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Bulk Rounds", tag: "Ammo" },
];

export const REVIEWS = [
  { name: "Matthew M.", loc: "Phoenix, AZ", stars: 5, text: "No matter if you're Wyatt Earp or a novice, the folks at NP Guns will treat you like family. They always take the time to walk you through the local gun laws and offer useful firearm suggestions." },
  { name: "Parker W.", loc: "Huntington Beach, CA", stars: 5, text: "Best gun shop in Mohave County. I refuse to give anyone else my business. The staff genuinely remembers me and treats me like family. Best shop around, hands down." },
  { name: "Al F.", loc: "Rancho Cucamonga, CA", stars: 5, text: "I've done business with Niel a few times now and he's been great. His prices are fantastic, and if he doesn't have it in stock he will order it." },
  { name: "Jun E.", loc: "Long Beach, CA", stars: 5, text: "This shop is amazing. The staff are like superheroes when they talk about gun safety. The gentlemen are genuinely nice and knowledgeable. Highly recommend to family and friends!" },
  { name: "Dennis D.", loc: "Redlands, CA", stars: 5, text: "Great place to shop. Very helpful, quality products, and very fair prices. I highly recommend them." },
  { name: "T T.", loc: "Big Bear Lake, CA", stars: 4, text: "Stopped by for ammo and the owner was very helpful and answered several questions I had. Thank you!" },
];

export const CHAPTERS = [
  { no: "01", title: "The Counter", body: "Walk in and you're not a transaction — you're a neighbor. We talk through your needs, the local laws, and what actually fits your hand." },
  { no: "02", title: "The Bench", body: "Every repair and build runs through hands that have done it a thousand times. Diagnostics done right, parts sourced honest, work you can stake your life on." },
  { no: "03", title: "The Range Mindset", body: "Safety first, always. From first-timers to lifelong shooters, we treat every firearm with the respect it demands and pass that discipline on to you." },
];

export const FLAG_BG = "https://images.unsplash.com/photo-1499696562547-dbe51006e1bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const HERITAGE = [
  {
    year: "1936",
    name: "M1 GARAND",
    war: "World War II",
    cal: ".30-06 Springfield",
    note: "\"The greatest battle implement ever devised.\" — Gen. George S. Patton. The semi-auto rifle that armed the Greatest Generation.",
    img: "https://images.unsplash.com/photo-1518719389402-b6beb27e88c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    year: "1959",
    name: "M14",
    war: "Cold War Era",
    cal: "7.62×51mm NATO",
    note: "America's last full-power battle rifle — hard-hitting, wood-stocked, and still revered by precision shooters today.",
    img: "https://images.unsplash.com/photo-1583872341575-610c859c7a57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    year: "1964",
    name: "M16",
    war: "The Vietnam War",
    cal: "5.56×45mm NATO",
    note: "Lightweight, fast, and revolutionary. Standard issue in the jungles of Vietnam, it changed the American service rifle forever.",
    img: "https://images.unsplash.com/photo-1722268383700-c75fb07f0b8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    year: "1994",
    name: "M4 CARBINE",
    war: "The Modern Warfighter",
    cal: "5.56×45mm NATO",
    note: "Compact, modular, and battle-proven across two decades of conflict. The M4 is the direct heir to the M16 — and the platform we know best.",
    img: "https://images.unsplash.com/photo-1669489890884-baff10f74b49?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
];
